import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { OrderSampleDomainModel } from '@app/lab-orders/models/domain/order-sample.domain.model';
import { LoginComponent } from '../login.component';
import { Store } from '@ngrx/store';
import * as fromApp from '../../../store/app.reducers';
import { DomSanitizer } from '@angular/platform-browser';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-login-modal',
    templateUrl: './login-modal.component.html',
    styleUrls: ['./login-modal.component.scss']
})

export class LoginModalComponent implements OnInit {
    @Input()
    isVisible = false;
    @Output()
    isVisibleChange = new EventEmitter<boolean>();
    @Output()
    saveComposites = new EventEmitter<OrderSampleDomainModel[]>();
    @ViewChild('loginComponent') loginComponent: LoginComponent;

    loginError$ = this.store.select(fromApp.getLoginError).pipe(
        map(raw => !!raw && this.sanitizer.bypassSecurityTrustHtml(raw))
    );

    constructor(
        private store: Store<fromApp.AppState>,
        private sanitizer: DomSanitizer
    ) {}

    ngOnInit() {}

    onClose() {
        this.loginComponent.setOptInAsGuest();
        this.isVisible = false;
        this.isVisibleChange.emit(this.isVisible);
    }

}
